import api from "./apiURL";

export const putDocumentVerification = async (data) => {
  try {
    const response = await api.put(`/api/v1/user/document/action`, data);
    return response.data;
  } catch (error) {
    console.error("Aadhar verification failed", error);
    throw error;
  }
};

// export const putNursingVerification = async (action) => {
//   try {
//     const response = await api.put(`/api/v1/user/document/action`, {
//       action,
//     });
//     return response;
//   } catch (error) {
//     console.error("Nursing verification failed", error);
//     throw error;
//   }
// };
